<template>
  <div>
    <div v-show="hasPermission(['IU CASH REQUEST VIEW'])">
    <pdf-viewer />
    <invoice-alert />
    <vx-card noShadow ref="filterCard" :title="$t('filters')" class="user-list-filters mb-8">

      <template slot="actions">
        
        <vx-tooltip
          delay="1.5s"
          :text="$t('check_next_cash_request')|capitalize"
          tooltipPosition="top"
          style="display: inline-block;"
      >
        <feather-icon
            icon="FileIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            @click="checkExpensesOnNextCashRequest"
          />
      </vx-tooltip>
        <vx-tooltip
          delay="1.5s"
          :text="$t('apply_filters')|capitalize"
          tooltipPosition="top"
          style="display: inline-block;"
      >
        <feather-icon
          icon="FilterIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="search" 
        />
      </vx-tooltip>
        <vx-tooltip
          delay="1.5s"
          :text="$t('clear_filters')|capitalize"
          tooltipPosition="top"
          style="display: inline-block;"
      >
        <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="resetFilters"/>
      </vx-tooltip>
        
        
      </template>
      <div class="vx-row mx-2">
        <div class="vx-col md:w-1/2 w-full">
          <label class="text-sm opacity-75">{{$t('client')}}</label>
          <v-select
            multiple
            :options="clients"
            v-model="client_id"
            label="ClientName"
            :reduce="el => el.ClientId"
            name="filterClient"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <label class="text-sm opacity-75">{{$t("year")}} - {{$t("week")}}</label>
          <v-select
            multiple
            :options="periods"
            v-model="period_id"
            :reduce="el => el.PeriodId"
            label="WeekInvoice"
            name="filterWeek"
          />
        </div>
      </div>
    </vx-card>
    <vx-card noShadow :title="$t('cash_request')">
      <invoice-table :ClientId="client_id" :PeriodId="period_id" :clients="clients" :periods="filteredPeriodsRequest" :reSearch="reSearch"/> 
    </vx-card>
    <!-- BEGGIN MODAL Gastos en Proximo Cash Request -->
    <vs-popup title="Gastos en Próximo Cash Request" :active.sync="modalNextCashRequest" fullscreen>
          <vs-row class="my-3">
              <vs-col vs-w="3">
                <b>{{ $t('client') }}:</b> {{ClientName}}
              </vs-col>
        </vs-row>
        
         <vs-tabs position="top">
          <vs-tab icon-pack="feather" icon="icon-book" :label="$t('expenses')">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <expense-sidelist :data="expensesNextCashRequest" :loadingMessage="loadingMessage"/>
            </div>
          </vs-tab> 
        </vs-tabs>
      </vs-popup>
    <!-- END MODAL -->
    </div>
  </div>
</template>

<script>
//import moduleInvoice from '@/store/invoice/moduleInvoice.js'
import InvoiceTable from '@/views/apps/cash_request/components/InvoiceTable.vue'
import InvoiceAlert from '@/views/apps/cash_request/components/InvoiceAlert.vue'
import ExpenseSidelist from '@/views/apps/accounting/components/ExpenseSidelist.vue'
import vSelect from 'vue-select'
import client from '@/http/requests/client'
import invoice from '@/http/requests/invoice'
import PdfViewer from '@/components/pdf/PdfViewer.vue'
import moduleInvoice from '@/store/invoice/moduleInvoice.js'
import moment from 'moment'
import recipient from '@/http/requests/recipient'

export default {
  components: {
    InvoiceTable,
    InvoiceAlert,
    ExpenseSidelist,
    vSelect,
    PdfViewer
  },
  data() {
    return {
      modal: false,
      clients: [],
      periods: [],
      searchValue:'',
      reSearch:1,
      client_id:null,
      period_id:null,
      filteredPeriodsRequest:[],
      //Modal
      modalNextCashRequest: false,
      expensesNextCashRequest:[],
      loadingMessage:'Cargando...',
      ClientName:''
    }
  },
  computed:{
    allowed_to_see_module () {
      const allowed = localStorage.getItem('permissions').includes('IU CASH REQUEST VIEW')
      return allowed
    }
  },
  created() {
    if (!moduleInvoice.isRegistered) {
      this.$store.registerModule('invoice', moduleInvoice)
      moduleInvoice.isRegistered = true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      client.list().then(res => {
        this.clients = res.data.clients
      })
      invoice.getPeriodList().then(res => {
        this.periods = res.data.periodList
        moment.locale('es');
        let today = moment().format('Y-MM-DD')
        let aWeekAgo = moment().subtract(13,'d').format('Y-MM-DD')
        let sixDaysAfter = moment().add(8,'d').format('Y-MM-DD')
        if( this.hasPermission(['IU CASH REQUEST PERIOD'])){
          this.filteredPeriodsRequest = this.periods
        }else{
          this.filteredPeriodsRequest = this.periods.filter((item) => {
          return (
            item.BeginDate >= aWeekAgo &&
            item.EndDate <= sixDaysAfter)
        })
        }
       
      })
    },
    search(){
      this.reSearch= this.reSearch+1
    },
    resetFilters() {
      this.period_id = null
      this.client_id = null
      this.search()
    },
    checkExpensesOnNextCashRequest(){
      if(this.client_id != null){
        if(this.client_id.length==1){
          this.expensesNextCashRequest=[]
            let params={
              ClientId:this.client_id,
              PeriodId:this.period_id
            }
            let client=this.clients.find(item => {return item.ClientId == this.client_id})
            if(client!=null){
              this.ClientName=client.ClientName
            }
            this.modalNextCashRequest=true
            this.loadingMessage = this.$i18n.messages[this.$i18n.locale].loading+'...'
            invoice.getExpensesNextCashRequest(params).then( res => {
              console.log(res.data);
              this.expensesNextCashRequest=res.data.expenses
              if (res.data.expenses.length == 0) {
                    this.loadingMessage =  this.$i18n.messages[this.$i18n.locale].no_results
                }
            }).catch(err => {
              this.loadingMessage ='Oops, Algo salió mal...'
            })
        }else{
         this.$vs.notify({
             color: 'warning',
             title: 'Alert',
             text: 'Seleccione Solamente Un cliente'
           }) 
        }
      }else{
        this.$vs.notify({
             color: 'warning',
             title: 'Alert',
             text: 'Seleccione Cliente'
           })
      }
    }
  }
}
</script>

<style>
</style>


